var pt_config_menu = {
        sel: {
            sidebarDrawerContainer: "#sidebar-menu .Drawer__Container",
            headerCloseBtn: "header button.Header__Icon--close",
            pt301CloseBtn: "button.pt301_closeBtn",
            collapsibleButton: "#sidebar-menu .Drawer__Container .SidebarMenu__Nav .Collapsible>button.Collapsible__Button",
            pt301MainMenuOpen: "pt301_mainMenu_open"
    }
  };
    var drawerContainer = document.querySelector(pt_config_menu.sel.sidebarDrawerContainer);
    var collapsibleMenuBtns = document.querySelectorAll(pt_config_menu.sel.collapsibleButton);
       collapsibleMenuBtns.forEach(function(btn) {
            btn.addEventListener("click", function(e) {
                "true" === e.currentTarget.getAttribute("aria-expanded") ? (drawerContainer.classList.contains(pt_config_menu.sel.pt301MainMenuOpen) && drawerContainer.classList.remove(pt_config_menu.sel.pt301MainMenuOpen), 
                e.currentTarget.parentElement.classList.remove(pt_config_menu.sel.pt301MainMenuOpen)) : (drawerContainer.classList.contains(pt_config_menu.sel.pt301MainMenuOpen) || drawerContainer.classList.add(pt_config_menu.sel.pt301MainMenuOpen), 
                e.currentTarget.parentElement.classList.add(pt_config_menu.sel.pt301MainMenuOpen));
            });
        });